<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">{{ cardTitle }}</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />
    <!--begin::Body-->
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">الاسم:</label>
          <div>{{ (dataRow.Admin)? dataRow.Admin.name : 'غير معروف' }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">بتاريخ:</label>
          <div class="date-format">{{ formatDate(dataRow.createdAt) }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">القسم:</label>
          <div>{{ modelNames[dataRow.modelName] }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">الحدث:</label>
          <div>{{ actionTypes[dataRow.actionType] }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">قبل الحدث:</label>
          <div class="english-input"><pre>{{ (dataRow.rowBefore)? dataRow.rowBefore : '' }}</pre></div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">بعد الحدث:</label>
          <div class="english-input"><pre>{{ (dataRow.rowAfter)? dataRow.rowAfter : '' }}</pre></div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 mb-3">
          <label for="" class="form-label">المعطيات:</label>
          <div class="english-input"><pre>{{ (dataRow.actionData)? dataRow.actionData : '' }}</pre></div>
        </div>
      </div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
import { formatDate } from '@/helpers/tools';

export default {
  name: 'HistoriesForm',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
    modelNames: {
      type: Object,
      default: null,
    },
    actionTypes: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
    }
  },
  methods: {
    formatDate,
  },
  created(){
  }
}
</script>
